module.exports = __webpack_public_path__ + "img/icone-sugarcane.ab7a4090.svg";